// ABOUTME: Registry mapping widget type strings to lazy-loaded React components.
// ABOUTME: Central lookup for rendering widgets in the custom pages layout system.

import { ComponentType, lazy, LazyExoticComponent } from 'react';

import { WidgetProps } from './types';

const widgetRegistry: Record<string, LazyExoticComponent<ComponentType<WidgetProps>>> = {
    'action-bar': lazy(() => import('./ActionBar')),
    chart: lazy(() => import('./ChartWidget')),
    'node-list': lazy(() => import('./NodeListWidget')),
    'node-editor': lazy(() => import('./NodeEditorWidget')),
    'node-tree': lazy(() => import('./NodeTreeWidget')),
    'linked-items': lazy(() => import('./LinkedItemsWidget')),
    'linked-by-items': lazy(() => import('./LinkedByItemsWidget')),
    'node-info': lazy(() => import('./NodeInfoWidget')),
    'favorite-nodes': lazy(() => import('./FavoriteNodesWidget')),
    'model-selection': lazy(() => import('./ModelSelectionWidget')),
    matrix: lazy(() => import('./MatrixWidget')),
    'card-grid': lazy(() => import('./CardGridWidget')),
    text: lazy(() => import('./TextWidget')),
    'completeness-overview': lazy(() => import('./CompletenessOverviewWidget')),
    'incomplete-nodes': lazy(() => import('./IncompleteNodesWidget')),
    'translation-coverage': lazy(() => import('./TranslationCoverageWidget')),
    'review-publish': lazy(() => import('./ReviewPublishWidget')),
    'channel-readiness-matrix': lazy(() => import('./ChannelReadinessMatrixWidget')),
    'channel-not-ready-nodes': lazy(() => import('./ChannelNotReadyNodesWidget')),
    'analytics-active-users': lazy(() => import('./AnalyticsActiveUsersWidget')),
    'analytics-top-events': lazy(() => import('./AnalyticsTopEventsWidget')),
    'analytics-user-activity': lazy(() => import('./AnalyticsUserActivityWidget')),
};

export default widgetRegistry;
